import { ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useTypePartnerCompany } from '~hooks/useTypePartnerCompany';
import { PATHS } from '~constants/paths';

import ComponentWithSuspense from '../ComponentWithSuspense';

interface RedirectHomeByGiverRouteProps {
  component: ReactNode;
}

const RedirectHomeByGiverRoute = ({
  component,
}: RedirectHomeByGiverRouteProps): ReactElement => {
  const { isGiver } = useTypePartnerCompany();

  if (isGiver) {
    return <Navigate to={PATHS.HOME.BASE} replace />;
  }

  return <ComponentWithSuspense component={component} />;
};

export default RedirectHomeByGiverRoute;
